import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton, BCPageRedirect } from "../../shared/styled/global.styled";

const AccessDenied = () => {
  const navigate = useNavigate();
  return (
    <LayoutMain idPage="accessDenied" titlePage={false}>
      <BCPageRedirect>
        <h1>Acceso Restringido</h1>
        <p>
          Si requiere acceso a esta funcionalidad solicitelo al administrador
          del sistema
        </p>
        <BCButton
          type="button"
          className="bc-button-primary bc-button-small"
          onClick={() => navigate("/")}
        >
          Ir al inicio
        </BCButton>
      </BCPageRedirect>
    </LayoutMain>
    
  );
};

export default AccessDenied;
